import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useLangStore = create(
  persist(
    (set) => ({
      lang: 'en',  // 'en' | 'ar'
      toggleLang: () => set(s => ({ lang: s.lang === 'en' ? 'ar' : 'en' })),
    }),
    { name: 'findr-lang' }
  )
);

export default useLangStore;
